// // // src/utils/trackingService.js
// // import {
// //   collection,
// //   addDoc,
// //   getDocs,
// //   serverTimestamp,
// //   query,
// //   orderBy,
// //   limit,
// // } from "firebase/firestore";
// // import { db } from "./firebase";
// // import servicesConfig from "./servicesConfig";

// // // ── Event types ──
// // export const TRACK_EVENTS = {
// //   // Service usage
// //   SERVICE_USED:          "SERVICE_USED",
// //   SERVICE_STARTED:       "SERVICE_STARTED",
// //   SERVICE_COMPLETED:     "SERVICE_COMPLETED",
// //   SERVICE_FAILED:        "SERVICE_FAILED",

// //   // Payment
// //   PAYMENT_INITIATED:     "PAYMENT_INITIATED",
// //   PAYMENT_SUCCESS:       "PAYMENT_SUCCESS",
// //   PAYMENT_FAILED:        "PAYMENT_FAILED",

// //   // Resume
// //   RESUME_UPLOADED:       "RESUME_UPLOADED",
// //   RESUME_ANALYZED:       "RESUME_ANALYZED",
// //   RESUME_GENERATED:      "RESUME_GENERATED",
// //   RESUME_DOWNLOADED:     "RESUME_DOWNLOADED",

// //   // Report
// //   REPORT_DOWNLOADED:     "REPORT_DOWNLOADED",

// //   // Auth
// //   USER_SIGNUP:           "USER_SIGNUP",
// //   USER_LOGIN:            "USER_LOGIN",
// //   USER_LOGOUT:           "USER_LOGOUT",

// //   // Page
// //   PAGE_VIEWED:           "PAGE_VIEWED",
// // };

// // // ── Get service info by code ──
// // export function getServiceByCode(serviceCode) {
// //   return servicesConfig.services.find(s => s.serviceCode === serviceCode) || null;
// // }

// // // ── Main tracking function ──
// // export async function trackEvent(userId, eventType, serviceCode, metadata = {}) {
// //   try {
// //     if (!userId) {
// //       console.warn("trackEvent: no userId provided");
// //       return;
// //     }

// //     const service = serviceCode ? getServiceByCode(serviceCode) : null;

// //     const eventData = {
// //       // Event info
// //       eventType,
// //       serviceCode:   serviceCode || null,
// //       serviceName:   service?.title || null,
// //       serviceId:     service?.id || null,

// //       // Metadata
// //       metadata,

// //       // Timestamps
// //       createdAt:     serverTimestamp(),
// //       date:          new Date().toISOString().split("T")[0], // YYYY-MM-DD for easy querying

// //       // User agent info
// //       userAgent:     navigator.userAgent || null,
// //       platform:      navigator.platform || null,
// //     };

// //     // Save to user's events subcollection
// //     await addDoc(
// //       collection(db, "users", userId, "events"),
// //       eventData
// //     );

// //     // Also save to global events collection for admin analytics
// //     await addDoc(
// //       collection(db, "serviceTracking"),
// //       {
// //         ...eventData,
// //         userId,
// //       }
// //     );

// //     console.log(`✅ Tracked: ${eventType} | ${serviceCode || "N/A"}`);

// //   } catch (err) {
// //     // Never break app flow for tracking errors
// //     console.error("❌ trackEvent error:", err.message);
// //   }
// // }

// // // ── Convenience tracking functions ──

// // // Track service start
// // export async function trackServiceStart(userId, serviceCode, metadata = {}) {
// //   await trackEvent(userId, TRACK_EVENTS.SERVICE_STARTED, serviceCode, metadata);
// // }

// // // Track service completion
// // export async function trackServiceComplete(userId, serviceCode, metadata = {}) {
// //   await trackEvent(userId, TRACK_EVENTS.SERVICE_COMPLETED, serviceCode, metadata);
// // }

// // // Track service failure
// // export async function trackServiceFail(userId, serviceCode, metadata = {}) {
// //   await trackEvent(userId, TRACK_EVENTS.SERVICE_FAILED, serviceCode, metadata);
// // }

// // // Track payment
// // export async function trackPayment(userId, status, metadata = {}) {
// //   const eventType = status === "success"
// //     ? TRACK_EVENTS.PAYMENT_SUCCESS
// //     : TRACK_EVENTS.PAYMENT_FAILED;
// //   await trackEvent(userId, eventType, null, metadata);
// // }

// // // Track resume analysis
// // export async function trackResumeAnalysis(userId, metadata = {}) {
// //   await trackEvent(userId, TRACK_EVENTS.RESUME_ANALYZED, "ATS_ANALYSIS", metadata);
// // }

// // // Track resume generation
// // export async function trackResumeGeneration(userId, metadata = {}) {
// //   await trackEvent(userId, TRACK_EVENTS.RESUME_GENERATED, "RESUME_GENERATOR", metadata);
// // }

// // // Track report download
// // export async function trackReportDownload(userId, format, metadata = {}) {
// //   await trackEvent(userId, TRACK_EVENTS.REPORT_DOWNLOADED, "REPORT_DOWNLOAD", {
// //     format,
// //     ...metadata,
// //   });
// // }

// // // Track resume download
// // export async function trackResumeDownload(userId, format, metadata = {}) {
// //   await trackEvent(userId, TRACK_EVENTS.RESUME_DOWNLOADED, "RESUME_GENERATOR", {
// //     format,
// //     ...metadata,
// //   });
// // }

// // // Track page view
// // export async function trackPageView(userId, pageName) {
// //   await trackEvent(userId, TRACK_EVENTS.PAGE_VIEWED, null, { page: pageName });
// // }

// // // Track auth events
// // export async function trackAuth(userId, eventType, metadata = {}) {
// //   await trackEvent(userId, eventType, null, metadata);
// // }

// // // ── Get user events history ──
// // export async function getUserEvents(userId, limitCount = 50) {
// //   try {
// //     const snapshot = await getDocs(
// //       collection(db, "users", userId, "events")
// //     );

// //     const events = snapshot.docs
// //       .map(d => ({ id: d.id, ...d.data() }))
// //       .sort((a, b) =>
// //         (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0)
// //       )
// //       .slice(0, limitCount);

// //     return events;
// //   } catch (err) {
// //     console.error("❌ getUserEvents error:", err);
// //     return [];
// //   }
// // }

// // // ── Get service usage summary for a user ──
// // export async function getUserServiceSummary(userId) {
// //   try {
// //     const events = await getUserEvents(userId, 500);

// //     const summary = {};
// //     servicesConfig.services.forEach(s => {
// //       summary[s.serviceCode] = {
// //         serviceCode: s.serviceCode,
// //         serviceName: s.title,
// //         icon: s.icon,
// //         totalUses: 0,
// //         lastUsed: null,
// //         completions: 0,
// //         failures: 0,
// //       };
// //     });

// //     events.forEach(e => {
// //       if (e.serviceCode && summary[e.serviceCode]) {
// //         summary[e.serviceCode].totalUses++;
// //         if (!summary[e.serviceCode].lastUsed) {
// //           summary[e.serviceCode].lastUsed = e.createdAt;
// //         }
// //         if (e.eventType === TRACK_EVENTS.SERVICE_COMPLETED) {
// //           summary[e.serviceCode].completions++;
// //         }
// //         if (e.eventType === TRACK_EVENTS.SERVICE_FAILED) {
// //           summary[e.serviceCode].failures++;
// //         }
// //       }
// //     });

// //     return summary;
// //   } catch (err) {
// //     console.error("❌ getUserServiceSummary error:", err);
// //     return {};
// //   }
// // }

// src/utils/trackingService.js
import {
  collection,
  addDoc,
  getDocs,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "./firebase";
import servicesConfig from "./servicesConfig";

// Get service info by code
export function getServiceByCode(serviceCode) {
  return servicesConfig.services.find(s => s.serviceCode === serviceCode) || null;
}

// Get plan info by id
export function getPlanById(planId) {
  return servicesConfig.plans.find(p => p.id === planId) || null;
}

// ── Only tracking we need — which service/plan user paid for ──
export async function trackServicePayment(userId, serviceCode, planId, metadata = {}) {
  try {
    if (!userId) return;

    const service = getServiceByCode(serviceCode);
    const plan = planId ? getPlanById(planId) : null;

    const record = {
      userId,
      serviceCode,
      serviceName:  service?.title || serviceCode,
      serviceIcon:  service?.icon || "",
      planId:       planId || "pay_per_use",
      planName:     plan?.name || "Pay Per Use",
      planPrice:    plan?.price || "$1.99",
      status:       "paid",
      metadata,
      createdAt:    serverTimestamp(),
      date:         new Date().toISOString().split("T")[0],
    };

    // Save to user's serviceUsage subcollection
    await addDoc(
      collection(db, "users", userId, "serviceUsage"),
      record
    );

    console.log(`✅ Service payment tracked: ${serviceCode}`);

  } catch (err) {
    console.error("❌ trackServicePayment error:", err.message);
  }
}

// ── Get user's service usage history ──
export async function getUserServiceUsage(userId) {
  try {
    const snapshot = await getDocs(
      collection(db, "users", userId, "serviceUsage")
    );
    if (snapshot.empty) return [];
    return snapshot.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .sort((a, b) =>
        (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0)
      );
  } catch (err) {
    console.error("❌ getUserServiceUsage error:", err);
    return [];
  }
}